function toggleSignUpDrawer(drawerToggleSelector, drawerContentSelector, closeButtonSelector) {
    const drawerToggle = document.querySelector(drawerToggleSelector);
    const drawerContent = document.querySelector(drawerContentSelector);
    const closeButton = document.querySelector(closeButtonSelector);
    const body = document.body;

    function openDrawer() {
        drawerToggle.classList.add('drawer-menu-opening');
        drawerContent.classList.add('open');
        body.classList.add('signup-drawer-open');
    }

    function closeDrawer() {
        drawerToggle.classList.remove('drawer-menu-opening');
        drawerContent.classList.remove('open');
        body.classList.remove('signup-drawer-open');
    }

    if (drawerToggle) {
        
        drawerToggle.addEventListener('click', function (event) {
            event.preventDefault();
            drawerToggle.classList.contains('drawer-menu-opening') ? closeDrawer() : openDrawer();
        });
    }

    $(closeButton).on('click', function (event) {
        event.preventDefault();
        closeDrawer();
    });
}

function initSignUpDrawer() 
{
    toggleSignUpDrawer('.header__icon.wi-header-right-signup-icon', '.wi-signup-drawer-wrapper', '.wi-right-header-close-button');
    toggleSignUpDrawer('.header__icon.wi-mobile-drawer-signup-icon', '.wi-mobile-menu-signup-drawer', '.wi-mobile-signup-close-button');
}


function VipInfoPopup() 
{
    $('.question_icon').click(function (e) 
    { 
      console.log("dzvevbfjeovjfebvfjesbvfjesbvfjdb");
        e.preventDefault();
        $('.vip_info_popup').addClass('active');
        $('body').addClass("overflow-hidden");
    });
    $('.lm').click(function (e) 
    { 
      console.log("doesnt work, why ? Fix in subscribfy-custom");
        e.preventDefault();
        $('.vip_info_popup').addClass('active');
        $('body').addClass("overflow-hidden");
    });

    $('.vip_popup_close_button').click(function (e) 
    { 
        e.preventDefault();
        $('.vip_info_popup').removeClass('active');
        $('body').removeClass("overflow-hidden");
    });
    $('.wi_vip_button_link').click(function (e) 
    { 
        e.preventDefault();
        $('.vip_info_popup').removeClass('active');
        $('body').removeClass("overflow-hidden");
    });
}

$(document).ready(function () 
{   
    initSignUpDrawer();

    // product page js
    VipInfoPopup();

    // Announcement bar tabs active feature
    // $('.wi_announcement_tabs span.tab').click(function (e) 
    // { 
    //     e.preventDefault();
    //     $('.wi_announcement_tabs span.tab').removeClass('active');
    //     $(this).addClass('active');
    // });

    $('.wi_icon.product-popup-modal__button').click(function (e) { 
        e.preventDefault();
        $('.wi_video_modal[open] video').trigger('play');
    });

    
    $('.sound_high.product-popup-modal__toggle').click(function (e) 
    { 
        e.preventDefault();
        $(this).addClass('hidden');
        $(this).next('.sound_muted').removeClass('hidden');
        $(".wi_video_modal[open] video").prop('muted', true);
    });

    $('.sound_muted.product-popup-modal__toggle').click(function (e) 
    { 
        e.preventDefault();
        $(this).addClass('hidden');
        $(this).parents('.wi_video_modal').find('.sound_high').removeClass('hidden');
        $(".wi_video_modal[open] video").prop('muted', false);
    });

    $('.video_play.product-popup-modal__toggle').click(function (e) 
    {
        e.preventDefault();
        $(".wi_video_modal[open] video").trigger('play');
        $(this).addClass('hidden');
        $(this).parents('.wi_video_modal').find('.video_pause').removeClass('hidden');
    });

    $('.video_pause.product-popup-modal__toggle').click(function (e) 
    {
        e.preventDefault();
        $(".wi_video_modal[open] video").trigger('pause');
        $(this).addClass('hidden');
        $(this).next('.video_play').removeClass('hidden');
    });

    $(document).on("click", function(e) 
    {
        
        if ($(e.target).hasClass('facets__header')) 
        {
            if ($(e.target).parent().attr('open')) 
            {
                $(e.target).parents('details').removeAttr('open');
                return false;
            }
        }
        else
        {
            if (!$(e.target).closest('.custom_horizontal_facets__list').length && !$(e.target).closest('details').length) 
            {
                $('.custom_horizontal_filter details[open]').removeAttr('open');
            }
        }
   
    }); 

    $(document).on("click",".password_eye_icon",function()
    {
        var input = $('.password_field');
        if (input.attr('type') == 'password') 
        {
            input.attr('type', 'text');
            $('.password_eye_slash_icon').addClass('active');
            $('.password_eye_open_icon').removeClass('active');
        } 
        else 
        {
            input.attr('type', 'password');
            $('.password_eye_slash_icon').removeClass('active');
            $('.password_eye_open_icon').addClass('active');
        }
        
    });

    $(document).on("click",".video_filter li",function()
    {
        $('.video_grid_wrapper').hide();
        var filter_name= $(this).text();
        filter_name = filter_name.toLowerCase().replace(' ', "_");
        if(filter_name == 'all')
        {
            $('.video_grid_wrapper').show();
            return;
        }
        $('.' + filter_name).show();
    });


    $(document).on("click",".toggle_account_block",function()
    {
        $('.account_menu_list ul li').removeClass('active');
        $(this).addClass('active');
        var classname = $(this).attr('data-show');    
        $('.toggle_account_content_block').addClass('hidden');
        $('.'+classname).removeClass('hidden');
    });

    var page_url = window.location.href;
    if(page_url.includes('order'))
    {
        $('.account_menu_list ul li').removeClass('active');
        $('.wi_order_detail').addClass('active');
        $('.wi_dashboard').addClass('hidden');
        $('.wi_order_detail').removeClass('hidden');
    }

    $(document).on("click",".select_mobile_menu li",function()
    {
        $('.small_account_menu').toggleClass('hidden');
        $('.select_mobile_menu .icon_wrapper').addClass('active');
    });

    $(document).on("click",".small_account_menu li",function()
    {
        $('.small_account_menu').addClass('hidden');
        const Selected_menu_icon = $(this).find('svg');
        const selected_menu_name = $(this).find('span').text();
        $('.select_mobile_menu li .menu_content_wrapper .image_wrapper').html(Selected_menu_icon);
        $('.select_mobile_menu li span').text(selected_menu_name);
        $('.select_mobile_menu .icon_wrapper').removeClass('active');
    });
    
    $(document).on("click",".order_filter",function()
    {
        $('.order_filter').removeClass('active');
        $(this).addClass('active');
        var classname = $(this).attr('data-order-filter');
        if(classname == 'all')
        {
            $('.toggle_order_content_block').removeClass('hidden');
            return;
        }
        $('.toggle_order_content_block').addClass('hidden');
        $('.'+classname).removeClass('hidden');
    });

    $(document).on("click",".starterkit_submit",function()
    {
        $('.active_add_to_cart_button').trigger('click'); 
    });

    
    
});